import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ArticlesComponent implements OnInit {

  public articleId: number | null = null;

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _router: Router,
  ) { }

  ngOnInit(): void {
    const rawId = this._route.snapshot.paramMap.get('id');
    if (!rawId) {
      return;
    }

    const id = Number(rawId);
    if (!Number.isInteger(id) || id <= 0) {
      this._router.navigateByUrl('/articles');
      return;
    }

    this.articleId = id;
  }

}
